/* eslint-disable-jsx-a11y/anchor-is-valid*/
import React, {useContext, useState, useEffect} from 'react';
import {Grid, TextField} from '@material-ui/core';
import BackButton from '../../Common/BackButton';
import RequiredInfo from '../../Common/RequiredInfo';
import useStyles from './styles';
import messages from './messages';
import AppButton from '../../Common/AppButton';
import SummaryView from '../SummaryView';
import AppContext from "../../../contexts/App/App.context";
import {cancelPa, updatePa} from '../../../shared/api-service';
import PriorAuthorizationContext from "../../../contexts/PriorAuthorization/PriorAuthorization.context";
import useUploadHelper from '../../FileUploadHelper'
import DropZoneInput from '../../Pages/CreatePa/InputTypes/DropZoneInput'
import {apiStatus} from "../../../shared/enums";
import {isNonEmpty} from '../../../shared/utils'

export default function Details(props) {

    const {
        authNumber,
        priorAuthStatusFromView,
        operation,
        status,
        fields,
        setState,
        setBanner,
        setStatus,
        setOperation,
        setModalState,
        inquiry: {rootOperation, setView, view, data, getRecords, requestId, advancedSearch, resendVerbiage}
        } = useContext(PriorAuthorizationContext);
    const { npiNumber, provider: {providerType} } = useContext(AppContext);
    const {
        title: {id, heading, getSubHeadingHTML, resendVerbiageHeading},
        backButton,
        submitButton,
        viewPAButton,
        cancelButton,
        inquiryActions,
        getUpdateMessage
    } = messages
    const [showSummary, setShowSummary] = useState(false)
    const [additionInfo, setAdditionInfo] = useState('')
    const {handleSubmit, uploadStatus, modalTitle, ...uploadInfo} = useUploadHelper({npiNumber, authNumber})
    const classes = useStyles()
    const modalDefaultState = {
        confirm: () => {},
        confirmText: 'YES, I attest',
        confirmToolTip:  'Confirm Cancel',
        denyText: 'No, Go Back',
        denyToolTip: 'Go Back',
        open: false,
        title: 'I attest the information provided is true and accurate to the best of my knowledge. I understand that Medi-Cal Rx or its designees may perform a routine audit and request the medical information necessary to verify the accuracy of the information reported on this form.'
    }
    const [actionSuccess, setActionSuccess] = useState(false)

    const paInfoPayload = {
      npi: npiNumber,
      operation,
      authNumber,
      beneficiaryDOB: fields.beneficiaryDOB.value,
      beneficiaryID: fields.beneficiaryID.value,
      beneficiaryLastName: fields.beneficiaryLastName.value,
      advancedSearch: false,
      requestId: advancedSearch ? requestId : null,
      providerType,
    };

    const record = data && data.find(item => {
        if(authNumber){
            return item.authNumber.toLowerCase() === authNumber.toLowerCase()
        }
        else if(requestId){
            return item.requestId.toLowerCase() === requestId.toLowerCase()
        }
        return null
    })
    const isInProgress = record && record.priorAuthStatus && record.priorAuthStatus.toLowerCase().includes('in progress');
    const isInquirySummary = (view === 'summary' && operation === 'inquiry');
    const startsWithWeb = record && record.authNumber && record.authNumber.toLowerCase().startsWith('web');
    const shouldShowRequiredFields = startsWithWeb && isInProgress && !isInquirySummary;
    const shouldShowInquiryActions =
      priorAuthStatusFromView === "In Progress" &&
      isInquirySummary &&
      startsWithWeb;
    const isCancelDisabled = () => {
        if(operation === 'cancel'){
            return actionSuccess
        }
        else if(operation === 'upload'){
            return uploadInfo.files.length === 0 || actionSuccess
        }
        else if(operation === 'update'){
            return additionInfo.trim().length === 0 || actionSuccess
        }
        return false
    }
    const isSubmitDisabled = () => {
        if(operation === 'upload'){
            return uploadInfo.files.length === 0 || actionSuccess
        }
        else if(operation === 'update'){
            return additionInfo.trim().length === 0 || actionSuccess
        }
        return false
    }
    const completeDetailsFlow = () => {
        setState(prev => ({
            ...prev,
            authNumber: advancedSearch ? '' : authNumber,
            operation: rootOperation,
            bannerProps: {
                message: null
            },
            modalState: {
                ...prev.modalState,
                open: false
            },
            status,
            inquiry: {
                ...prev.inquiry,
                view: 'results'
            }
        }))
    }
    const closeBanner = () => {
        setState(prev => ({
            ...prev,
            bannerProps: {
                message: null
            }
        }))
    }
    const bannerDefaultState = {
        message: '',
        severity: '',
        onClick: completeDetailsFlow
    }

    const cancelPAAction = async () => {

        const bannerProps = {
            ...bannerDefaultState,
            message: '',
            severity: '',
        }

        let status = '';

        try {
            setStatus(apiStatus.LOADING)
            const cancelPayload = {...data[0]}
            cancelPayload.providerType = providerType
            cancelPayload.priorAuthStatus = 'R'
            const response = await cancelPa(cancelPayload)
            status = response.errMsg ? apiStatus.ERROR : apiStatus.SUCCESS;
            bannerProps.message = response.errMsg
            bannerProps.severity = response.errMsg ? 'error' : 'success'
            if(!response.errMsg){
                setActionSuccess(true)
                setView('cancelSuccess', operation);
            }
            else {
                bannerProps.onClick = closeBanner
            }
        } catch(error) {
            status = apiStatus.ERROR;
            bannerProps.message = error.message || 'System Error: Please try again later.';
            bannerProps.severity = 'error';
            bannerProps.onClick = closeBanner
        } finally {
            setModalState({open: false});
            setState(prev => ({
                ...prev,
                bannerProps,
                status
            }))
        }
    }

    const getSubmitOnClick = () => {
        setModalState({...modalDefaultState, 
            open: true,
            deny: cancelAttestModal,
            confirm: confirmAttestation
        });
    }
    const cancelAttestModal = () => {
        setModalState({open: false});
    }
    const confirmAttestation = async () => {
        const bannerProps = {
            ...bannerDefaultState,
            message: '',
            severity: '',
        }
        const now = new Date();
        const formatted = new Intl.DateTimeFormat('en-US', {
            dateStyle: 'short',
            timeStyle: 'medium',
            timeZone: 'America/Los_Angeles'
        }).format(now)
        let status = '';
        cancelAttestModal()
        if (operation === 'upload'){
            handleSubmit()
        }
        else if(operation === 'update'){
            (async () => {
                try{
                    setStatus(apiStatus.LOADING)
                    const updatePayload = {...data[0]}
                    updatePayload.additionalInformation = `${formatted} (PT): ${additionInfo.trim()}`
                    updatePayload.providerType = providerType
                    const response = await updatePa(updatePayload)
                    status = response.errMsg ? apiStatus.ERROR : apiStatus.SUCCESS;
                    bannerProps.message  = response.errMsg ? response.errMsg : getUpdateMessage(record.authNumber)
                    bannerProps.severity = response.errMsg ? 'error' : 'success'
                    if(!response.errMsg){
                        setActionSuccess(true)
                    }
                    else {
                        bannerProps.onClick = closeBanner
                    }
                }
                catch(error){
                    status = apiStatus.ERROR
                    bannerProps.message = error.message || 'System Error: Please try again later.'
                    bannerProps.severity = 'error'
                    bannerProps.onClick = closeBanner
                }
                finally{
                    setState( prev => ({
                        ...prev,
                        bannerProps,
                        status
                    }))
                }
            })()
        }
    }
    const uploadFilesError = ({severity, message}) => {
        setBanner({...bannerDefaultState,
            open: true,
            message,
            severity,
            onClick: () => setBanner({message: null})
        })
    }

    useEffect( () => {
        if (operation !== 'cancelSuccess') {
            getRecords(paInfoPayload)
        }
    // eslint-disable-next-line
    }, [operation])
    useEffect(() => {
        //console.log('useEffect uploadInfo.files')
        if( uploadInfo.files.length > 0){
            window.onbeforeunload = event => {
                event.returnValue = "Are you sure?"
            }
        }
        else {
            window.onbeforeunload = () => null
        }

        // Cleanup to detach refresh trigger once we unmount this component
        return () => window.onbeforeunload = () => null
    // eslint-disable-next-line
    }, [uploadInfo.files])
    useEffect( () => {
        if( isInProgress == null || (operation === 'inquiry') ){
            setShowSummary(true)
        }
        else{
            setShowSummary(false)
        }
    // eslint-disable-next-line
    }, [isInProgress])

    useEffect(() => {
        if( uploadStatus !== apiStatus.DEFAULT ){
            const severity = uploadStatus === apiStatus.SUCCESS ? 'success' : 'error'
            const message = uploadStatus === apiStatus.LOADING ? null : modalTitle
            setState( prev => {
                return {
                    ...prev,
                    status: uploadStatus,
                    bannerProps: {
                        ...bannerDefaultState,
                        message,
                        severity,
                    }
                }
            })
            setActionSuccess(uploadStatus === apiStatus.SUCCESS)
        }
    // eslint-disable-next-line
    }, [uploadStatus])

    const closeModal = () => {
        setModalState({open: false})
        setView('results', operation);
    }
    const initCancel = () => {
        setModalState({
            open: true,
            confirm: cancelPAAction,
            confirmText: 'Yes, Cancel',
            confirmToolTip:  'Confirm Cancel',
            deny: closeModal,
            denyText: 'No, Go Back',
            denyToolTip: 'Go Back',
            title: "Are you sure you want to cancel this prior authorization request? All information will be lost."
        })
    }

    return (

        <Grid container spacing={2} className={classes.root}>

            <Grid container spacing={2} item>

                <Grid container item xs={4} sm={3} md={2}>
                    <div id={`${backButton.id}_${Math.floor(Math.random()*(50000-2 +1) + 2)}`} data-testid={backButton.id}>
                        <BackButton onClick={completeDetailsFlow}/>
                    </div>
                </Grid>
                { (!record || !data || data.length === 0) && status !== apiStatus.LOADING &&
                <Grid container justify='center' item xs={12}>
                    <h1 className={classes.error}>
                        There was an error fetching this record. Please try searching again.
                    </h1>
                </Grid>
                }
                { record && data && data.length > 0 &&
                <>
                <Grid container item xs={8} sm={9} md={10}>
                    { shouldShowRequiredFields && <RequiredInfo /> }
                </Grid>

                <Grid container spacing={2} item style={{margin: '3rem'}}>

                    {/* Body */}
                    <Grid container spacing={2} item xs={7} sm={9}>

                        {/* Heading */}
                        <Grid container item xs={12}>
                            <Grid item sm={12} lg={3}>
                                <h1 data-testid={id} id={id} >{heading}</h1>
                            </Grid>
                            <Grid container alignItems={'flex-start'} item sm={12} lg={9} >
                                <div
                                    className={classes.heading}
                                    dangerouslySetInnerHTML={getSubHeadingHTML(record.authNumber, record.priorAuthStatus, priorAuthStatusFromView)}
                                />
                            </Grid>
                            { operation === 'inquiry' && isNonEmpty(resendVerbiage) &&
                                <>
                                    <Grid item sm={12}>
                                        <h1 className={classes.resendVerbiage} id={id} >{resendVerbiageHeading}</h1>
                                    </Grid>
                                    <Grid container alignItems={'flex-start'} item sm={12} >
                                        <div className={classes.heading}>
                                            <span className={classes.resendVerbiageText}>{resendVerbiage}</span>
                                        </div>
                                    </Grid>
                                </>
                            }
                        </Grid>

                        { isInProgress &&
                        <>
                            { operation === 'upload' &&
                            <>
                                <DropZoneInput
                                    disabled={actionSuccess}
                                    setBanner={uploadFilesError}
                                    uploadInfo={uploadInfo}
                                    enableModal={false}
                                />
                            </>
                            }
                            { operation === 'update' &&

                                <div style={{ width: '100%', paddingTop: '0.5rem'}}>
                                    <Grid container spacing={2} direction='column'>

                                        <Grid item xs={12}>
                                            <RequiredInfo mode="asterisk"/>
                                            <span className={classes.additionalInfo}>
                                                Additional Information:
                                            </span>
                                        </Grid>
                                        <Grid container direction='column' item xs={12}>
                                            <TextField
                                                disabled={actionSuccess}
                                                multiline
                                                variant='outlined'
                                                value={additionInfo}
                                                onChange={ e => setAdditionInfo(e.target.value)}
                                                rows={6}
                                                inputProps={{maxLength: 1500, style: {width: '100%'}, "aria-label": "Additional Information text area"}}
                                            />
                                            <div style={{paddingTop: '0.5rem', display: 'flex', flexDirection: 'row-reverse'}}>
                                                <span>Characters Remaining: {1500-additionInfo.length}/{1500}</span>
                                            </div>
                                        </Grid>

                                    </Grid>
                                </div>

                            }
                        </>
                        }

                        {/* Provider info */}
                        { showSummary  &&
                            <Grid container item xs={12} >
                                <SummaryView record={record}/>
                            </Grid>
                        }
                    </Grid>

                    {/* Action Buttons */}
                    <Grid container spacing={3} direction={'column'} alignItems={'center'} justify={'flex-start'} item xs={5} sm={3}>
                        { isInProgress &&
                        <>
                            { (operation === 'upload' ||
                                operation === 'cancel' ||
                                operation === 'update') &&
                            <>
                                {operation === 'cancel' &&  
                                    <Grid item>
                                        <AppButton {...cancelButton }
                                                text="Cancel PA"
                                                size='large'
                                                disabled={isCancelDisabled()}
                                                onClick={initCancel}
                                        />
                                    </Grid>
                                }
                                <Grid item >
                                    <AppButton
                                        {...viewPAButton}
                                        onClick={()=>setShowSummary(true)}
                                        size='large'
                                    />
                                </Grid>
                                { (operation === 'upload' ||
                                    operation === 'update') &&
                                    <>
                                    <Grid item>
                                        <AppButton {...submitButton }
                                                size='large'
                                                text={operation === 'update' ? 'Add Information' : submitButton.text}
                                                tooltip={operation === 'update' ? 'Add Information' : submitButton.text}
                                                disabled={isSubmitDisabled()}
                                                onClick={getSubmitOnClick}
                                        />
                                    </Grid>
                                        <Grid item>
                                            <AppButton {...cancelButton }
                                                       text='Cancel'
                                                       size='large'
                                                       disabled={isCancelDisabled()}
                                                       onClick={completeDetailsFlow}
                                            />
                                        </Grid>
                                    </>
                                }
                            </>
                            }
                            { shouldShowInquiryActions &&
                            <>
                                {inquiryActions.map( (action, index) => {
                                    return(
                                        <Grid item key={index}>
                                            {/* <Link to={action.to}> */}
                                                <AppButton {...action }
                                                           size='large'
                                                           onClick={()=>setOperation(action.operation)}
                                                />
                                            {/* </Link> */}
                                        </Grid>
                                    )
                                })}
                            </>
                            }
                        </>
                        }
                    </Grid>

                </Grid>
                </>
                }
            </Grid>
        </Grid>
    )

}